// extracted by mini-css-extract-plugin
export default {"wrapper":"StartPage_wrapper__XJuaO","button":"StartPage_button__Y+mjb"};